var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "wf-product-room-scene-viewer wf-product-quick-view-modal justify-content-around",
      class: _vm.isRug && _vm.viewMode === "swatch" ? "rug-image" : ""
    },
    [
      _vm.viewMode === "swatch"
        ? [
            _c(
              "button",
              {
                staticClass: "btn wf-product-room-scene-viewer-button-close",
                attrs: { type: "button" },
                on: { click: _vm.setViewMode }
              },
              [
                _c("span", {
                  staticClass: "png-icon png-icon-icons-glyph--k-close",
                  attrs: { "aria-label": "Close view mode 'swatch'" }
                })
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass:
                  "btn wf-product-room-scene-viewer-button-plus p-0 shadow",
                attrs: { type: "button" },
                on: { click: _vm.zoomIn }
              },
              [
                _c("span", {
                  staticClass:
                    "\n            plus-sm-icon\n            png-icon\n            png-icon-icons-glyph--red-plus-sm\n            wf-product-refinement-list-header-toggle-inactive\n          "
                })
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass:
                  "btn wf-product-room-scene-viewer-button-minus p-0 shadow",
                attrs: { type: "button" },
                on: { click: _vm.zoomOut }
              },
              [
                _c("span", {
                  staticClass:
                    "\n            plus-sm-icon\n            png-icon\n            png-icon-icons-glyph--red-minus-sm\n            wf-product-refinement-list-header-toggle-inactive\n          "
                })
              ]
            )
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }